import React from 'react'

const Footer = () => {
    return(
        <footer class="pt-10 px-10 py-10 max-md:px-5 mt-20 max-[420px]:mt-0">
        <div class="w-3/5 grid grid-cols-3 max-[1100px]:w-4/5 max-md:w-full max-sm:grid max-sm:grid-cols-1 max-sm:gap-10">
          <div class="text-center max-sm:text-center">
            <h2 class="font-bold text-white text-lg">Resources</h2>
            <p class="text-white font-normal mt-7">Policies</p>
            <p class="text-white font-normal mt-3">Reports</p>
            <p class="text-white font-normal mt-3">Speeches</p>
            <p class="text-white font-normal mt-3">Downloads</p>
            <p class="text-white font-normal mt-3">Pre-releases</p>
            <p class="text-white font-normal mt-3">Guidelines and manuals</p>
          </div>

          <div class="text-center max-md:ml-3 max-sm:text-center">
            <h2 class="font-bold text-white text-lg">Links</h2>
            <p class="text-white font-normal mt-7"><a href="#home">Tenders</a></p>
            <p class="text-white font-normal mt-3"><a href="#about">Health facts</a></p>
            <p class="text-white font-normal mt-3"><a href="#contact">Afya answers</a></p>
            <p class="text-white font-normal mt-3"><a href="#home">Privacy Policies</a></p>
            <p class="text-white font-normal mt-3"><a href="#about">Compliments/Complaints</a></p>
            <p class="text-white font-normal mt-3"><a href="#contact">Vacancies and Postings</a></p>
          </div>

          <div class="ml-4 text-center max-md:ml-3 max-sm:text-center">
            <h2 class="font-bold text-white text-lg">Covid</h2>
            <p class="text-white font-normal mt-7">Videos</p>
            <p class="text-white font-normal mt-3">Situation Reports</p>
            <p class="text-white font-normal mt-3">Campaign Posters</p>
            <p class="text-white font-normal mt-3">Vaccination Posters</p>
            <p class="text-white font-normal mt-3">Protocols and Guidelines</p>
            <p class="text-white font-normal mt-3">Research and studies</p>
          </div>
        </div>
      </footer>
    )
}

export default Footer